import { Instagram, Facebook, Twitter, Cloud, Ghost, AtSign, Link2 } from "lucide-react";

/**
 * Renders a row of social icons for a Post.
 * Only renders icons whose underlying field is populated.
 * Accepts either a full URL or a bare handle (with or without @).
 */

const PLATFORMS = [
    {
        key: "instagram",
        label: "Instagram",
        Icon: Instagram,
        toUrl: (v) => buildUrl(v, "https://instagram.com/"),
    },
    {
        key: "facebook",
        label: "Facebook",
        Icon: Facebook,
        toUrl: (v) => buildUrl(v, "https://facebook.com/"),
    },
    {
        key: "twitter",
        label: "X",
        Icon: Twitter,
        toUrl: (v) => buildUrl(v, "https://x.com/"),
    },
    {
        key: "bluesky",
        label: "Bluesky",
        Icon: Cloud,
        toUrl: (v) => buildUrl(v, "https://bsky.app/profile/"),
    },
    {
        key: "snapchat",
        label: "Snapchat",
        Icon: Ghost,
        toUrl: (v) => buildUrl(v, "https://snapchat.com/add/"),
    },
    {
        key: "threads",
        label: "Threads",
        Icon: AtSign,
        toUrl: (v) => buildUrl(v, "https://threads.net/@"),
    },
    {
        key: "other_social",
        label: "Other",
        Icon: Link2,
        toUrl: (v) => (v.startsWith("http") ? v : `https://${v.replace(/^\/+/, "")}`),
    },
];

function buildUrl(value, base) {
    const v = String(value || "").trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v;
    return `${base}${v.replace(/^@/, "")}`;
}

export default function PostSocialLinks({ post }) {
    if (!post) return null;
    const items = PLATFORMS.filter((p) => (post[p.key] || "").trim());
    if (items.length === 0) return null;

    return (
        <div
            className="mt-6 flex flex-wrap items-center gap-3"
            data-testid="post-social-links"
            aria-label="Social profiles"
        >
            <span className="font-poppins text-xs tracking-[0.18em] uppercase text-[#1B1B1B]/60">
                Follow
            </span>
            {items.map(({ key, label, Icon, toUrl }) => (
                <a
                    key={key}
                    href={toUrl(post[key])}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    title={label}
                    className="inline-flex items-center justify-center h-10 w-10 bg-[#1B1B1B] text-white hover:bg-[#E63B26] hover:text-white transition"
                    data-testid={`post-social-${key}`}
                >
                    <Icon className="h-4 w-4" />
                </a>
            ))}
        </div>
    );
}
